var exports = {
  "kL": "xe7b6e3d6--a98223--container",
  "Qs": "xe7b6e3d6--a98223--content",
  "qr": "xe7b6e3d6--a98223--footer",
};

module.exports = exports;
